import { SLOTS_APIS } from "@/api_framework/api_config";

import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import { IBookingSlotsResponse } from "@/api_framework/api_modals/Bookings";

import AxiosCurlirize from "axios-curlirize";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useBookingNearestClinicListAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [data, setData] = useState([]);

  const execute = useCallback(
    async (lat?: string, long?: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios

          .get(`${SLOTS_APIS?.NEAREST_CLINIC_FETCH?.baseURL}?latitude=${lat}&longitude=${long}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IBookingSlotsResponse>) => {
            if (res.data.status === true) {
              setData(res.data.data);
            } else {
              setData([]);
            }
          })
          .catch((e: AxiosError) => {
            // captureError(e);
            sendCurl(e.config["curlCommand"]);

            setData([]);
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        setData([]);
      }
    },
    [dispatch],
  );
  return { execute, data };
};
